import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveCalendarHolidaysNotificationState = createStateReducer(
  initialState,
  {
    [events.removeCalendarHolidaysSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeCalendarHolidays",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeCalendarHolidaysFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeCalendarHolidays",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceRemoveCalendarHolidaysNotificationState };
